import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ShipmentChargesTable from "../../components/ShipmentCharges/ShipmentChargesTable";
import ShipmentDurationTable from "../../components/ShipmentDuration/ShipmentDurationTable";
import ShipmentDurationV2 from "../../components/ShipmentDuration/ShipmentDurationV2";



const ShipmentDuration = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Shipment Duration" />
                {/* <ShipmentChargesTable/> */}
                {/* <ShipmentDurationTable/> */}
                <ShipmentDurationV2/>



            </MasterLayout>
        </>
    );
};

export default ShipmentDuration;
